import Layout from '@/layout/paycools-index.vue'
// import i18n from '@/lang'

export const serviceProviderToolsRouter = {
  path: '/serviceProviderTools',
  component: Layout ,
  redirect: '/serviceProviderTools/merchantList',
  name: 'Service_Provider_Tools',
  alwaysShow: true,
  meta: { title: 'service_provider_tools', icon: 'service-provider' },
  children: [
    {
      path: 'merchantList',
      name: 'Merchant_List',
      component: () => import('@/views/paycools/service-provider-tools/merchant-list'),
      meta: {
        title: 'merchant_list', noCache: false,
        auth: ['AUTH_CODE_MERCHANT_LIST']
      }
    },
    {
      path: 'transactionRecords/:merchant_no/:merchant_name',
      name: 'Transaction_Records',
      component: () => import('@/views/paycools/service-provider-tools/transaction-records'),
      meta: {
        title: 'transaction_records', noCache: false,
        auth: ['AUTH_CODE_MERCHANT_LIST']
      },
      hidden: true
    }
  ]
}
